import { jsx as r, jsxs as s } from "react/jsx-runtime";
import a from "react";
import { VisuallyHidden as c } from "../../VisuallyHidden/VisuallyHidden.js";
import m from "./StepperItem.js";
import { Wrapper as d, Box as l, StepsLineContainer as h, StepLine as f, ListContainer as u } from "./styled.js";
const S = ({ items: o, activeStepName: p }) => {
  const n = o.findIndex((e) => e === p), i = (o.length - 1) * 69 + 25;
  return /* @__PURE__ */ r(d, { children: /* @__PURE__ */ s(l, { children: [
    /* @__PURE__ */ r(h, { height: i, children: /* @__PURE__ */ r(f, {}) }),
    /* @__PURE__ */ r(c, { as: "h2", children: "Progress indicator" }),
    /* @__PURE__ */ r(u, { children: o.map((e, t) => /* @__PURE__ */ r(
      m,
      {
        index: t,
        name: e,
        mode: t === n ? "Current" : t < n ? "Past" : "Future"
      },
      `${t}_${e}`
    )) })
  ] }) });
}, _ = a.memo(S);
export {
  _ as default
};
